import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  Card,
  CardHeader,
} from "@mui/material";

import React, { useEffect, useState } from "react";

import TextEditorComponent from "../../common/components/TextEditorComponent";
import { connect } from "react-redux";
import { showError } from "../../toastify";
import { updateCasePendingLetter } from "../../../store/discipline/actions";
import CustomizedLetter from "../../common/components/CustomizedLetter";
import InfoIcon from "@mui/icons-material/Info";
import moment from "moment";

const maxCharCount = 1500;

const ViewLetterDialog = (props) => {
  const {
    action,
    pendingLetter,
    employee,
    setShowLetter,
    showLetter,
    enableToFillLetter,
    loading,
    updateCasePendingLetter,
    rejected,
    cancelled,
    selectedLetter,
    onUpdateLetter,
    signContent,
    setEnableToFillLetter,
    isEmployeeDelayedToRespond
  } = props;

  const [letter, setLetter] = useState(selectedLetter || pendingLetter);

  const [localStorageKey, setLocalStorageKey] = useState({
    letter: `${letter?.caseId}-draftCaseContent`,
    cc: `${letter?.caseId}-copiedInstitution`,
  });
  const [formData, setFormData] = useState({
    id: letter?.id,
    caseId: letter?.caseId,
    letterBodyContent: letter?.letterBodyContent,
    ccInstitutionNames: letter?.ccInstitutionNames,
  });

  const [letterFooterContent, setLetterFooterContent] = useState(null);
  const [ccEmails, setCCEmails] = useState(
    letter && !!letter.ccEmails ? JSON.parse(letter?.ccEmails || []) : []
  );
  // console.log(localStorageKey);
  useEffect(() => {
    window.localStorage.setItem(
      localStorageKey.letter,
      letter?.letterBodyContent
    );
    window.localStorage.setItem(localStorageKey.cc, letter?.ccInstitutionNames);
  }, [letter]);

  useEffect(() => {
    if (onUpdateLetter) {
      formData.letterBodyContent = window.localStorage.getItem(
        localStorageKey.letter
      );
      formData.ccInstitutionNames = window.localStorage.getItem(
        localStorageKey.cc
      );
      formData.ccEmails = JSON.stringify(ccEmails);
      onUpdateLetter(formData);
    }
  }, [formData, ccEmails]);

  const onClose = () => {
    setShowLetter(false);
  };

  const getEditorContent = (data) => {
    setFormData((prevForm) => ({
      ...prevForm,
      letterBodyContent: data.contents,
    }));
  };
  const getEditorContent3 = (data) => {
    // console.log(data);
    setFormData((prevForm) => ({
      ...prevForm,
      ccInstitutionNames: data.contents,
    }));
    // letter.ccInstitutionNames = data.contents;
  };
  const handleLoadFooterContent = (data) => {
    // console.log(data);
    setLetterFooterContent(data);
  };

  const handleUpdateLetter = (isGoingNextPage) => {

    if (!letterFooterContent?.entity?.acronym) {
      showError(`The institution acronym is missing! ask your HR to update it.`);
      return false;
    }

    if (
      !!letterFooterContent &&
      !letterFooterContent?.entity?.institutionPhone
    ) {
      showError(`The institution phone number is required. Please update it`);
      return false;
    }

    if (
      letterFooterContent?.entity?.institutionPhone.includes("+25078XXXXXXX")
    ) {
      showError(
        `The institution phone number (${
          letterFooterContent?.entity?.institutionPhone || ""
        }) does not seem correct. Please update it.`
      );
      return false;
    }

    if (
      !!letterFooterContent &&
      !letterFooterContent?.entity?.institutionEmail
    ) {
      showError(`The institution email is required. Please update it`);
      return false;
    }

    if (letterFooterContent?.entity?.institutionEmail.includes("example")) {
      showError(
        `The institution email (${
          letterFooterContent?.entity?.institutionEmail || ""
        }) does not seem correct. Please update it.`
      );
      return false;
    }

    if (!!letterFooterContent && !letterFooterContent?.entity?.poBox) {
      showError(`The institution PO.Box is required. Please update it`);
      return false;
    }

    if (!!letterFooterContent && !letterFooterContent?.entity?.websiteUrl) {
      showError(`The institution website url is required. Please update it`);
      return false;
    }
    if (!!letterFooterContent && !letterFooterContent?.entity?.twitterPage) {
      showError(
        `The institution former(twitter) is required. Please update it`
      );
      return false;
    }
    formData.letterBodyContent = window.localStorage.getItem(
      localStorageKey.letter
    );

    if (formData?.letterBodyContent.includes("[Enter text here]")) {

      showError("Kindly update your letter, as it appears you have not made any edits yet.");
      return;
    }


    formData.ccInstitutionNames = window.localStorage.getItem(
      localStorageKey.cc
    );
    formData.ccEmails = JSON.stringify(ccEmails);
    updateCasePendingLetter(letter?.id, formData, (status) => {
      if (!!isGoingNextPage && !!status) setEnableToFillLetter(false);
    });
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showLetter}
        fullWidth
        maxWidth={"md"}
      >
        <DialogTitle>
          <Typography
            variant="overline"
            display="block"
            className="font-weight-bold"
          >
            <span
              class={`badge bg-${
                letter?.letterStatusId === 1
                  ? "primary"
                  : letter?.letterStatusId === 2
                  ? "success"
                  : letter?.letterStatusId === 4
                  ? "warning"
                  : "danger"
              } text-white px-2`}
            >
              {letter?.letterStatusName}
            </span>{" "}
            - {letter?.letterNo || ""} <br />
            <span className="text-primary">{letter?.letterDesc || ""}</span>
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent className="mt-0 mx-0" dividers>
          <Box sx={{ width: "100%", minHeight: "95vh" }} className="mt-1">
            <div className="mx-2 w-full">
              {!!isEmployeeDelayedToRespond && (
                <Card
                  className={`rounded hoverable-card mb-2 pb-0`}
                  variant="outlined"
                  sx={{
                    backgroundColor: `hsl(355, 98%, 29%)`,
                    border: "none",
                  }}
                >
                  <CardHeader
                    className="pb-0 my-0 mx-1"
                    style={{ padding: "0px" }}
                    avatar={
                      <span className={`font-weight-bold text-white`}>
                        <InfoIcon />
                      </span>
                    }
                    title={
                      <>
                        <strong className="text-white  mt-0">
                        Your response to the requested explanation concerning your disciplinary fault(s) is now overdue.
                        </strong>
                      </>
                    }
                  />
                </Card>
              )}
              <CustomizedLetter
                planningEntityId={
                  employee?.planningEntityId || letter?.planningEntityId || null
                }
                enableToFillLetter={enableToFillLetter}
                rejected={rejected}
                cancelled={cancelled}
                ccEmails={ccEmails}
                docLetterNo={letter?.letterNo || ""}
                address={employee?.address}
                signContent={signContent}
                entitySectorId={employee?.entitySectorId || null}
                letterBodyContentInput={
                  <>
                    <TextEditorComponent
                      id="editor-exit-textarea"
                      options={{
                        autoSave: false,
                        localStorageKey: localStorageKey.letter,
                        maxCharCount: maxCharCount,
                        defaultValue: !!window.localStorage.getItem(
                          localStorageKey.letter
                        )
                          ? window.localStorage.getItem(localStorageKey.letter)
                          : formData?.letterBodyContent,

                        styles: {
                          fontFamily:
                            letterFooterContent?.styles?.fontFamily || "",
                          fontSize: letterFooterContent?.styles?.fontSize || "",
                          textAlign:
                            letterFooterContent?.styles?.textAlign || "",
                          lineHeight:
                            letterFooterContent?.styles?.lineHeight || "",
                        },
                      }}
                      onEditorChange={(data) => {
                        // console.log(data);
                        getEditorContent(data);
                      }}
                    />
                  </>
                }
                letterBodyContent={formData?.letterBodyContent || ""}
                // title={letter?.letterTitle || ""}

                loadFooterContent={(data) => handleLoadFooterContent(data)}
              />
            </div>
          </Box>
        </DialogContent>

        {action && (
          <>
            <DialogActions className="d-flex justify-content-center py-2">
              {enableToFillLetter && (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    className="float-right px-5 my-1"
                    onClick={() => {
                      handleUpdateLetter(true);
                    }}
                  >
                    {loading ? "Wait.." : <>Save and sign</>}
                  </Button>
                </>
              )}

              {action}
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
};

const mapStateToProps = ({ loading, pendingLetter }) => {
  return {
    loading,
    pendingLetter,
  };
};
export default connect(mapStateToProps, { updateCasePendingLetter })(
  ViewLetterDialog
);
